export default __webpack_public_path__ + "static/media/10-SundtHus.b1874d33.png";